import { createRoutine } from 'redux-saga-routines';

const FETCH_PAYMENTS_ACTION_PREFIX = 'FETCH_PAYMENTS_ACTION';
export const fetchPaymentsAction = createRoutine(FETCH_PAYMENTS_ACTION_PREFIX);
